import { render } from "./Pallet Types.vue?vue&type=template&id=1ef4714c"
import script from "./Pallet Types.vue?vue&type=script&lang=js"
export * from "./Pallet Types.vue?vue&type=script&lang=js"

import "./Pallet Types.vue?vue&type=style&index=0&id=1ef4714c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__